import { render, staticRenderFns } from "./EditCompanyTasksBadgesView.vue?vue&type=template&id=0ab77a7c"
import script from "./EditCompanyTasksBadgesView.vue?vue&type=script&lang=js"
export * from "./EditCompanyTasksBadgesView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports